import React, { useState, useContext, useEffect } from 'react'
import { AppContext } from '../App'
import useFirebase from './../firebase/useFirebase'
import { format, subDays, formatDistance } from 'date-fns'
import fr from 'date-fns/locale/fr'
import useForm from '../hooks/useForm'

const INITIAL_STATE = {
    name:''
}

const people = [
    {
      name: 'James',
      age: 31,
    },
    {
      name: 'John',
      age: 45,
    },
    {
      name: 'Paul',
      age: 65,
    },
    {
      name: 'Ringo',
      age: 49,
    },
    {
      name: 'George',
      age: 34,
    }
]

const PageTest = () => {
    const [montage, setMontage] = useState(true)
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const { readData, writeData, readDataMessagesChat, clients, messagesChat } = useFirebase()
    const { handleChange, values, refresh } = useForm(INITIAL_STATE)
    const [count, setCount] = useState(0)
    const [loyaltyCard, setLoyaltyCard] = useState(10)
    const [num, setNum] = useState(1)

    useEffect(() => {
        window.scrollTo(0, 0)
        setMontage(false)
    },[])

    useEffect(() => {
        readData(keyUid) 
        readDataMessagesChat(keyUid) 
    },[montage])

    const _displayCard = () => {
        const array = []
        for (let i = 1; i < 11; i++) {
            array.push(i)
        }
        return array
    }

    const _subtractCardFidelity = () => {
        if (count > 0) {
            setCount(count - 1)
        }
    }

    const _addCardFidelity = () => {
        if (count < loyaltyCard) {
            setCount(count + 1)
        }
    }

    const _deleteCardFidelity = () => {
        if (count === 10) {
            setCount(0)
        }
    }

    return (
        <div className='container'> 
            <div>
                {people.filter(person => person.name.includes('James')).map((filteredPerson, i) => (
                    <li key={filteredPerson.name}>
                        {filteredPerson.name} {i}
                    </li>
                ))}
            </div>
            <div className='coledoedfjdklmfdjfldmfjdlfkjdlkdjlkdjlkdj'></div>
            <div className='row'></div>
        </div>
    )
}

export default PageTest

/*
        <div className='container'> 
            <div className='text-center my-5'>page test</div>
            <div className='d-inline-flex'>
                <button className='btn btn-outline-dark' style={{ width:40 }} onClick={_subtractCardFidelity}>-</button>
                <h4 className='mx-3'>{count}</h4>
                <button className='btn btn-outline-dark' style={{ width:40 }} onClick={_addCardFidelity}>+</button>
                {count === 10 &&
                    <button className='btn btn-outline-success ms-5' onClick={_deleteCardFidelity}>service offert</button>
                }
            </div>

        </div>
*/
